export const APP_ROUTES = {
  default: '/',
  catchAll: '*',
  cdfiReport: '/cdfi-page',
  cdfiCertification: '/cdfi-certification-page',
  redirectPage: '',
} as const;
